import { ReactNode, createContext, useContext } from 'react'
import { Api } from '~/core/trpc'

const useInternal = () => {
  const {
    data: settings,
    isFetched,
    refetch,
  } = Api.settings.findFirst.useQuery()

  return {
    settings,
    isFetched,
    refetch,
  }
}

type SettingsContext = ReturnType<typeof useInternal>

const SettingsContext = createContext<SettingsContext>(undefined)

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
  const value = useInternal()

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  )
}

export const useSettingsContext = (): SettingsContext => {
  const context = useContext(SettingsContext)

  if (context === undefined) {
    throw new Error('useSettingsContext must be used within a SettingsProvider')
  }

  return context
}
